import React from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export const DetailsAccordion = ({ title, children, expanded, onChange, ...props }) => {
	const { sx, otherProps } = props ?? {};
	return (
		<Accordion
			elevation={0}
			disableGutters
			square
			expanded={expanded}
			onChange={onChange}
			sx={{
				backgroundColor: 'transparent',
				width: '100%',
				'&:not(:last-child)': {
					borderBottom: 0,
				},
				'&::before': {
					display: 'none',
				},
				...(sx ?? {}),
			}}
			{...otherProps}
		>
			<AccordionSummary
				expandIcon={<ExpandMore sx={(theme) => ({ color: theme.palette.primary.main })} />}
				sx={(theme) => ({
					borderBottom: expanded ? `1px solid ${theme.palette.divider}` : 'none',
					padding: 0,
					marginBottom: '1em',
				})}
			>
				<Typography variant='form_label'>{title}</Typography>
			</AccordionSummary>
			<AccordionDetails sx={{ padding: '0px' }}>{children}</AccordionDetails>
		</Accordion>
	);
};
